import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import {fetchMonthlySummaryPreviousDataSuccess, fetchMonthlySummaryNextDataSuccess, fetchMonthlySummaryDataFailed} from '../actions/monthlySummaryActions';

export function fetchMonthlySummaryData( uuid,options, isPreviousData){
    return dispatch => {
        axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/monthly-summary-widget-data', {
            params: options
        }).then(
            (response) =>{
                if(isPreviousData){
                    dispatch(fetchMonthlySummaryPreviousDataSuccess(response.data.payload));
                } else { 
                    dispatch(fetchMonthlySummaryNextDataSuccess(response.data.payload));
                }
            },
            (error) => {
                dispatch(fetchMonthlySummaryDataFailed(error))
            }
        )
    }
}
